const AppleBoxIcon = ({color}) => {
  return (
    <svg
      width="123"
      height="124"
      viewBox="0 0 123 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <rect x="22" y="13" width="79" height="79" rx="16" fill="#020202" />
      </g>
      <path
        d="M76.3712 59.0549C75.8326 60.3127 75.1951 61.4704 74.4564 62.5348C73.4495 63.9859 72.6251 64.9903 71.9897 65.5481C71.0048 66.4636 69.9496 66.9325 68.8196 66.9591C68.0084 66.9591 67.03 66.7258 65.8913 66.2525C64.7487 65.7814 63.6987 65.5481 62.7387 65.5481C61.7318 65.5481 60.6519 65.7814 59.4969 66.2525C58.34 66.7258 57.4081 66.9725 56.6956 66.9969C55.612 67.0436 54.5319 66.5614 53.4538 65.5481C52.7656 64.9414 51.905 63.9014 50.8739 62.4282C49.7676 60.8549 48.8581 59.0305 48.1456 56.9506C47.3825 54.704 47 52.5285 47 50.4223C47 48.0097 47.5158 45.9289 48.5488 44.1852C49.3607 42.7845 50.4408 41.6797 51.7926 40.8686C53.1444 40.0575 54.6051 39.6442 56.1781 39.6177C57.0388 39.6177 58.1674 39.8868 59.5701 40.4157C60.9687 40.9464 61.8668 41.2155 62.2605 41.2155C62.5549 41.2155 63.5525 40.9008 65.2438 40.2735C66.8432 39.6917 68.193 39.4509 69.2988 39.5457C72.2953 39.7902 74.5465 40.9841 76.0437 43.1352C73.3638 44.7765 72.0381 47.0753 72.0645 50.0243C72.0887 52.3214 72.9131 54.2329 74.5333 55.7506C75.2676 56.455 76.0876 56.9994 77 57.3861C76.8021 57.9661 76.5933 58.5216 76.3712 59.0549ZM69.4989 31.7202C69.4989 33.5206 68.8482 35.2017 67.5511 36.7576C65.9858 38.6073 64.0925 39.6762 62.0394 39.5075C62.0132 39.2915 61.998 39.0642 61.998 38.8253C61.998 37.0969 62.7424 35.2472 64.0643 33.7348C64.7243 32.9691 65.5637 32.3323 66.5816 31.8244C67.5972 31.3241 68.558 31.0474 69.4615 31C69.4879 31.2407 69.4989 31.4814 69.4989 31.7202V31.7202Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0.698332"
          width="123"
          height="123"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="9.69833" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AppleBoxIcon;
